module.exports = __webpack_public_path__ + "img/tu2-3.a9a0dd3a.png";